export default __webpack_public_path__ + "static/media/mobile_victory.806329e8.webp";